module.exports = __webpack_public_path__ + "img/g_selected.3f40a09f.png";